<template>
    <section class="gmp-section gmp-mb-l">
        <div class="hero-landing">
            <div class="hero-landing__background hero-landing__overview">
                <div class="gmp-banner gmp-overview-hero">
                    <picture>
                        <img class="gmp-no-grab hero-landing__image" src="@/assets/img/enter2.png"
                             alt="Meaningful insights.<br>Smarter marketing.<br>Better results.">
                    </picture>
                </div>
            </div>
            <div class="hero-landing__content">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col--12 h-c-grid__col--align-middle">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                简单易用的原料品控和成本管理系统
                            </h1>
                            <h2 class="h-c-headline h-c-headline--four">
                                使用微信小程序开始订货、采购、出入库、成本核算分析。每一种原料从进货到生产、库存、损耗、废弃，所有原料终端和库房对数据实时查询。
                            </h2>
<!--                            <a href="/" class="h-c-button h-c-button&#45;&#45;primary">-->
<!--                                <div class="gmp-link__content gmp-link__content&#45;&#45;cta-btn">-->
<!--                                    <span>注册企业采购账号</span>-->
<!--                                </div>-->
<!--                            </a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "EI_heroLanding"
    }
</script>

<style lang="less">


</style>